"use client";

import React from "react";
import { Loader, Lock, Shield, ShieldCheck } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function ContactFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center gap-4 py-12 px-6 border border-primary/20 rounded-md bg-primary/5">
        <ShieldCheck className="size-12" style={{
        color: "var(--primary)"
      }} />
        <p className="text-center font-default text-lg font-medium" style={{
        color: "var(--primary)"
      }}>
          {successMessage}
        </p>
        <Button variant="outline" onClick={resetForm} className="font-default border-primary/40 hover:border-primary mt-2 uppercase tracking-wider">
          [ SCHEDULE ANOTHER VEHICLE ]
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5">
      {}
      <FormField control={control} name="name" rules={{
      required: "Name is required",
      minLength: {
        value: 2,
        message: "Minimum 2 characters"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default text-xs uppercase tracking-widest font-bold" style={{
        color: "var(--muted-foreground)"
      }}>
              <Lock className="size-3 inline mr-1" style={{
          color: "var(--primary)"
        }} />
              Owner Name
            </FormLabel>
            <FormControl>
              <input type="text" placeholder="Enter your full name" className="w-full font-default text-sm px-4 py-3 rounded-md outline-none transition-all" style={{
          background: "var(--input)",
          color: "var(--foreground)",
          border: "1px solid var(--border)",
          boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)"
        }} onFocus={e => {
          e.currentTarget.style.borderColor = "var(--primary)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05), 0 0 0 1px var(--primary)";
        }} onBlur={e => {
          e.currentTarget.style.borderColor = "var(--border)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05)";
        }} {...field} />
            </FormControl>
            <FormDescription className="font-default text-xs italic" style={{
        color: "var(--muted-foreground)"
      }}>
              The name for the service record.
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      {}
      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default text-xs uppercase tracking-widest font-bold" style={{
        color: "var(--muted-foreground)"
      }}>
              <Lock className="size-3 inline mr-1" style={{
          color: "var(--primary)"
        }} />
              Email Address
            </FormLabel>
            <FormControl>
              <input type="email" placeholder="your@email.com" className="w-full font-default text-sm px-4 py-3 rounded-md outline-none transition-all" style={{
          background: "var(--input)",
          color: "var(--foreground)",
          border: "1px solid var(--border)",
          boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)"
        }} onFocus={e => {
          e.currentTarget.style.borderColor = "var(--primary)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05), 0 0 0 1px var(--primary)";
        }} onBlur={e => {
          e.currentTarget.style.borderColor = "var(--border)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05)";
        }} {...field} />
            </FormControl>
            <FormDescription className="font-default text-xs italic" style={{
        color: "var(--muted-foreground)"
      }}>
              For appointment confirmation.
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      {}
      <FormField control={control} name="phone" rules={{}} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default text-xs uppercase tracking-widest font-bold" style={{
        color: "var(--muted-foreground)"
      }}>
              <Lock className="size-3 inline mr-1" style={{
          color: "var(--primary)"
        }} />
              Phone Number
              <span className="ml-2 text-xs font-default opacity-50">[REQUIRED]</span>
            </FormLabel>
            <FormControl>
              <input type="tel" placeholder="(518) 555-0123" className="w-full font-default text-sm px-4 py-3 rounded-md outline-none transition-all" style={{
          background: "var(--input)",
          color: "var(--foreground)",
          border: "1px solid var(--border)",
          boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)"
        }} onFocus={e => {
          e.currentTarget.style.borderColor = "var(--primary)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05), 0 0 0 1px var(--primary)";
        }} onBlur={e => {
          e.currentTarget.style.borderColor = "var(--border)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05)";
        }} {...field} />
            </FormControl>
            <FormDescription className="font-default text-xs italic" style={{
        color: "var(--muted-foreground)"
      }}>
              We'll call you when your vehicle is ready.
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      {}
      <FormField control={control} name="year" rules={{
      required: "Year is required",
      minLength: {
        value: 2,
        message: "Minimum 2 characters"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default text-xs uppercase tracking-widest font-bold" style={{
        color: "var(--muted-foreground)"
      }}>
              <Lock className="size-3 inline mr-1" style={{
          color: "var(--primary)"
        }} />
              Vehicle Year
            </FormLabel>
            <FormControl>
              <input type="text" placeholder="e.g. 2018" className="w-full font-default text-sm px-4 py-3 rounded-md outline-none transition-all" style={{
          background: "var(--input)",
          color: "var(--foreground)",
          border: "1px solid var(--border)",
          boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)"
        }} onFocus={e => {
          e.currentTarget.style.borderColor = "var(--primary)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05), 0 0 0 1px var(--primary)";
        }} onBlur={e => {
          e.currentTarget.style.borderColor = "var(--border)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05)";
        }} {...field} />
            </FormControl>
            <FormDescription className="font-default text-xs italic" style={{
        color: "var(--muted-foreground)"
      }}>
              Vehicle year
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      {}
      <FormField control={control} name="make" rules={{
      required: "Make is required",
      minLength: {
        value: 2,
        message: "Minimum 2 characters"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default text-xs uppercase tracking-widest font-bold" style={{
        color: "var(--muted-foreground)"
      }}>
              <Lock className="size-3 inline mr-1" style={{
          color: "var(--primary)"
        }} />
              Vehicle Make
            </FormLabel>
            <FormControl>
              <input type="text" placeholder="e.g. Toyota" className="w-full font-default text-sm px-4 py-3 rounded-md outline-none transition-all" style={{
          background: "var(--input)",
          color: "var(--foreground)",
          border: "1px solid var(--border)",
          boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)"
        }} onFocus={e => {
          e.currentTarget.style.borderColor = "var(--primary)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05), 0 0 0 1px var(--primary)";
        }} onBlur={e => {
          e.currentTarget.style.borderColor = "var(--border)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05)";
        }} {...field} />
            </FormControl>
            <FormDescription className="font-default text-xs italic" style={{
        color: "var(--muted-foreground)"
      }}>
              Vehicle make
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      {}
      <FormField control={control} name="model" rules={{
      required: "Model is required",
      minLength: {
        value: 2,
        message: "Minimum 2 characters"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default text-xs uppercase tracking-widest font-bold" style={{
        color: "var(--muted-foreground)"
      }}>
              <Lock className="size-3 inline mr-1" style={{
          color: "var(--primary)"
        }} />
              Vehicle Model
            </FormLabel>
            <FormControl>
              <input type="text" placeholder="e.g. Camry" className="w-full font-default text-sm px-4 py-3 rounded-md outline-none transition-all" style={{
          background: "var(--input)",
          color: "var(--foreground)",
          border: "1px solid var(--border)",
          boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)"
        }} onFocus={e => {
          e.currentTarget.style.borderColor = "var(--primary)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05), 0 0 0 1px var(--primary)";
        }} onBlur={e => {
          e.currentTarget.style.borderColor = "var(--border)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05)";
        }} {...field} />
            </FormControl>
            <FormDescription className="font-default text-xs italic" style={{
        color: "var(--muted-foreground)"
      }}>
              Vehicle model
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      {}
      <FormField control={control} name="message" rules={{
      required: "Message is required",
      minLength: {
        value: 10,
        message: "Minimum 10 characters"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default text-xs uppercase tracking-widest font-bold" style={{
        color: "var(--muted-foreground)"
      }}>
              <Lock className="size-3 inline mr-1" style={{
          color: "var(--primary)"
        }} />
              Vehicle Symptoms
            </FormLabel>
            <FormControl>
              <textarea rows={5} placeholder="Describe the issues or service needed (e.g., brake squeal, oil change, 100k mile service)..." className="w-full font-default text-sm px-4 py-3 rounded-md outline-none transition-all resize-none" style={{
          background: "var(--input)",
          color: "var(--foreground)",
          border: "1px solid var(--border)",
          boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)"
        }} onFocus={e => {
          e.currentTarget.style.borderColor = "var(--primary)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05), 0 0 0 1px var(--primary)";
        }} onBlur={e => {
          e.currentTarget.style.borderColor = "var(--border)";
          e.currentTarget.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.05)";
        }} {...field} />
            </FormControl>
            <FormDescription className="font-default text-xs italic" style={{
        color: "var(--muted-foreground)"
      }}>
              Help our mechanics prepare for your visit.
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 rounded-md border font-default text-sm" style={{
      background: "var(--destructive)/10",
      borderColor: "var(--destructive)",
      color: "var(--destructive)"
    }}>
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} size="lg" className="w-full font-default tracking-widest uppercase text-sm font-bold shadow-md hover:shadow-lg transition-all" style={{
      background: isSubmitting ? "var(--primary)/70" : "var(--primary)",
      color: "var(--primary-foreground)"
    }}>
        {isSubmitting ? <>
            <Loader className="animate-spin size-4 mr-2" />
            PROCESSING...
          </> : <>
            <Shield className="size-4 mr-2" />
            CONFIRM APPOINTMENT
          </>}
      </Button>
    </Form>;
}
export default function InitiateContact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="232068" id="schedule-your-visit" className="bg-background text-foreground py-20 px-4 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: "linear-gradient(var(--primary) 0.5px, transparent 0.5px), linear-gradient(90deg, var(--primary) 0.5px, transparent 0.5px)",
      backgroundSize: "60px 60px"
    }} />

    <div ref={ref} className="relative z-10 max-w-xl mx-auto transition-all duration-700 ease-out" style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(32px)"
    }}>
        {}
        <div className="flex items-center justify-center gap-3 mb-3">
          <ShieldCheck className="size-5" style={{
          color: "var(--primary)"
        }} />
          <span className="font-default text-xs uppercase tracking-widest font-bold" style={{
          color: "var(--primary)"
        }}>ESTABLISHED 1921</span>
          <ShieldCheck className="size-5" style={{
          color: "var(--primary)"
        }} />
        </div>

        <h2 className="font-default text-center text-4xl font-bold mb-2 tracking-tighter uppercase" style={{
        color: "var(--foreground)"
      }}>
          Schedule Your Visit
        </h2>
        <p className="font-serif text-center text-lg mb-8 italic" style={{
        color: "var(--muted-foreground)"
      }}>
          Trusted automotive care for over a century in Albany.
        </p>

        {}
        <div className="rounded-lg p-8 border" style={{
        background: "var(--card)",
        borderColor: "var(--border)",
        boxShadow: "var(--shadow-xl)"
      }}>
          {}
          <div className="flex items-center gap-2 mb-6 pb-4 border-b" style={{
          borderColor: "var(--border)"
        }}>
            <div className="w-2 h-2 rounded-full animate-pulse" style={{
            background: "var(--chart-2)"
          }} />
            <span className="font-default text-xs uppercase tracking-widest font-bold" style={{
            color: "var(--muted-foreground)"
          }}>
              SERVICE BAY AVAILABILITY ACTIVE
            </span>
          </div>

          <FormProvider formKey="appointment_form_book_appointment" formId="appointment_form_book_appointment" sectionName="schedule-your-visit" defaultValues={{
          name: "",
          email: "",
          phone: "",
          year: "",
          make: "",
          model: "",
          message: ""
        }} validationRules={{
          name: {
            required: true,
            minLength: 2
          },
          email: {
            required: true,
            pattern: "email"
          },
          phone: {
            required: true
          },
          year: {
            required: true,
            minLength: 2
          },
          make: {
            required: true,
            minLength: 2
          },
          model: {
            required: true,
            minLength: 2
          },
          message: {
            required: true,
            minLength: 10
          }
        }} submitText="Confirm Appointment" successMessage="Appointment request received. Dott's Garage will contact you shortly to finalize your time slot." errorMessage="Booking failed. Please check your details or call us directly at (518) 555-0123.">
            <ContactFormInner />
          </FormProvider>

          {}
          <div className="flex items-center justify-center gap-2 mt-6 pt-4 border-t" style={{
          borderColor: "var(--border)"
        }}>
            <ShieldCheck className="size-4" style={{
            color: "var(--primary)"
          }} />
            <span className="font-default text-xs font-medium" style={{
            color: "var(--muted-foreground)"
          }}>&nbsp;• Albany's Trusted Garage</span>
            <ShieldCheck className="size-4" style={{
            color: "var(--primary)"
          }} />
          </div>
        </div>
      </div>
    </section>;
}